import { render, staticRenderFns } from "./FinishedContestTab.vue?vue&type=template&id=dc7a5f54"
import script from "./FinishedContestTab.vue?vue&type=script&lang=js"
export * from "./FinishedContestTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports